<template>
    <v-dialog
            :value="messageId !== false"
            @input="close"
            max-width="600px"
            scrollable
    >
        <v-card class="modal-card" v-if="message">
            <v-card-title class="pa-6">Сообщение</v-card-title>
            <div class="message-date">{{ $dayjs(message.created_at).format('DD MMMM YYYY в HH:mm') }}</div>
            <v-card-text style="height: 400px;" class="pa-6">
                <div class="message-group">
                    <div class="message-heading">
                        <div class="message-heading__title">Получатели</div>
                        <v-spacer></v-spacer>
                        <div class="message-heading__actions">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn class="v-btn--collapse"
                                           x-small
                                           fab
                                           depressed
                                           color="primary"
                                           v-on="on"
                                           @click.prevent="showAll=!showAll"
                                           :class="{collapsed: showAll}">
                                        <v-icon>mdi-chevron-up</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ showAll ? 'Свернуть' : 'Развернуть' }}</span>
                            </v-tooltip>
                        </div>
                    </div>
                    <div class="message-clients">
                        <v-chip-group :column="showAll" :mobile-breakpoint="1920">
                            <v-chip v-for="client in message.clients"
                                    :key="client.id"
                                    :to="{name: 'clients.show', params: {clientId: client.id}}"
                                    small
                            >
                                <v-icon left small>mdi-account</v-icon>
                                <span>{{client.name}}</span>
                            </v-chip>
                        </v-chip-group>
                    </div>
                </div>
                <div class="message-group">
                    <div class="message-heading">
                        <div class="message-heading__title">Текст сообщения</div>
                    </div>
                    <div class="message-text">{{message.text}}</div>
                </div>
            </v-card-text>

            <v-card-actions class="px-6 py-5">
                <v-spacer></v-spacer>
                <v-btn depressed dark color="blue-grey" @click="close" min-width="120">Закрыть</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import messageApi from '../api/message.api';

    export default {
        name   : "MessageShowDialog",
        props  : {
            messageId: {
                required: true,
                default : false
            }
        },
        data() {
            return {
                message: null,
                showAll: false
            }
        },
        watch  : {
            messageId() {
                if (false !== this.messageId) {
                    this.$store.commit('setLoading', true);

                    messageApi.find(this.messageId).then(({data}) => {
                        this.message = data.data;
                    }).catch(() => {
                        this.$toast.error('Что-то пошло не так. Пожалуйста, повторите попытку позже');
                    }).finally(() => {
                        this.$store.commit('setLoading', false);
                    });
                }
            }
        },
        methods: {
            close() {
                Object.assign(this.$data, this.$options.data());
                this.$emit('close');
            },
        }
    }
</script>

<style scoped>

</style>
